//import packages from node modules
import React, { useEffect, useState, useCallback, useRef } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'

//import utility functions
import ACCOUNT_API from '../../../utilities/api/account'

import {
    LOCALE_STRING_OPTIONS,
    LOCALE_LANG_OPTIONS
} from '../../../utilities/function/common'

import {
    getDataFromSuccessResponse,
    getErrorFromFailResponse
} from '../../../utilities/function/apiResponse'

import {getAppConfigValue} from "../../../utilities/function/configuration"
import finished_image from '../../../utilities/images/order-complete.svg'
import Loading from '../../shared/loading'
import {NEW_CREDIT_CARD, SAVED_CREDIT_CARD} from '../../shared/paymentoptions'
import {withRouter} from 'react-router-dom'
import { appInit, resetCart } from '../../../app/action'
import SolidButton from '../../shared/button/solidbutton'
import Feedback from '../../../components/shared/feedback'

const getFinishedImageURL = () => {
    let url = finished_image
    if (window.app_config && window.app_config.complete_icon) {
        url = window.app_config.complete_icon
    }
    return url
}

let Finished = (props) => {
    const dispatch = useDispatch()
    const {
        finished
    } = useSelector(state => ({
        finished: state.app.finished
    }))

    const { history } = props
    const [requestUser, setRequestUser] = useState({})
    const [requestInvoice, setRequestInvoice] = useState({})

    useEffect(() => {
        if (Object.keys(finished).length > 0 && finished.constructor === Object) {
            const { invoice_id } = finished
            if (requestInvoice.status === undefined) {
                if (invoice_id) {
                    setRequestInvoice({
                        ...requestInvoice,
                        status: 'loading'
                    })
                    ACCOUNT_API.getInvoice(invoice_id).then(succesresponse => {
                        const data = getDataFromSuccessResponse(succesresponse)
                        appInit(dispatch, history, false)
                        setRequestInvoice({
                            ...requestInvoice,
                            status: 'success',
                            data
                        })
                    }, errorresponse => {
                        const error = getErrorFromFailResponse(errorresponse)
                        setRequestInvoice({
                            ...requestInvoice,
                            status: 'error',
                            error
                        })
                    })
                }
            }
        }
        else {
            history.push(history.location.pathname)
        }

    }, [finished, requestInvoice, history, dispatch])
    useEffect(() => {
        if (requestUser.status === undefined) {
            resetCart(dispatch)
            const { invoice_id } = finished
            if (invoice_id) {
                setRequestUser({
                    ...requestUser,
                    status: 'loading'
                })
                ACCOUNT_API.getUser().then(successresponse => {
                    const data = getDataFromSuccessResponse(successresponse)
                    setRequestUser({
                        ...requestUser,
                        status: 'success',
                        data
                    })
                }, errorresponse => {
                    const error = getErrorFromFailResponse(errorresponse)
                    setRequestUser({
                        ...requestUser,
                        status: 'error',
                        error
                    })
                })
            }
        }
    }, [finished, requestUser, dispatch])


    //check fraud
    //finished.manual_review = true
    //requestUser.status ="error"
    //requestInvoice.status ="error"

    const googleReviewCodeInit = useRef(null)
    const googleReviewCodeCallback = useCallback(() => {
        if (requestUser && requestInvoice && requestUser.data && requestUser.data.attributes &&
            requestInvoice.data && requestInvoice.data.attributes && finished && !googleReviewCodeInit.current) {
            const { email, country } = requestUser.data.attributes
            const { date } = requestInvoice.data.attributes
            const { order_id } = finished
            const date_formatted = moment(date).format("YYYY-MM-DD")
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            const renderOptIn = () => {
                const merchant_id = process.env.REACT_APP_GOOGLE_REVIEW_MERCHANT_ID || getAppConfigValue('google_review_merchant_id')
                if (window && window.gapi && typeof window.gapi.load === "function" && merchant_id) {
                    window.gapi.load('surveyoptin', () => {
                        window.gapi.surveyoptin.render({
                            merchant_id,
                            order_id,
                            email,
                            "delivery_country": country,
                            "estimated_delivery_date": date_formatted
                        })
                        googleReviewCodeInit.current = true
                    })
                }
            }
            script.onload = function () {
                renderOptIn();
            }
            script.src = 'https://apis.google.com/js/platform.js';
            head.appendChild(script);
        }
        return (<></>)
    }, [requestUser, requestInvoice, finished, googleReviewCodeInit])

    // useEffect(() => {
    //     googleReviewCodeCallback()
    // }, [googleReviewCodeCallback])

    const renderLoading = () => {
        if (requestUser.status === 'loading' || requestInvoice.status === 'loading') {
            return (<Loading className={'of-finished__loading'} wrapper={true} />)
        }
        return (<></>)
    }
    const renderLoginButon = () => {
        if (window && window.app_config && window.app_config.ccp_link) {
            return (
                <div className={'of-finished-header__button-wrapper'}>
                    <SolidButton onClick={e => {
                        e.preventDefault()
                        window.location.href = window.app_config.ccp_link
                    }} className={'of-finished-header__button checkout-sidebar-background-1-100'} isSecondary={true}>Proceed to Dashboard</SolidButton>
                </div>
            )
        }

    }
    const renderHeading = () => {
        const renderText = () => {
            if (finished && finished.manual_review) {
                return (<><br />We just need to check some things for you.</>)
            }
            return (
                <><br />We received your order!</>
            )
        }
        if (requestUser.status === 'success' && requestUser.data && requestUser.data.attributes && finished) {
            const { firstname } = requestUser.data.attributes
            const { order_id } = finished
            return (<div className={'of-finished-header'}>
                <img src={getFinishedImageURL()} className={'of-finished-header__image'} alt={'Thanks All Good'} />
                <div className={'of-finished-header__heading text-font-1-100'}>Thanks {firstname}!{renderText()}</div>
                <div className={'of-finished-header__sub-heading text-font-3-100'}>Your order number
                    is <strong className={'text-font-1-100'}>{order_id ? '#' + order_id : '#' + 436679}</strong></div>
                {renderLoginButon()}
            </div>)
        } else {
            if (requestUser.status === 'error' && finished && finished.manual_review) {
                return (<div className={'of-finished-header'}>
                    <img src={getFinishedImageURL()} className={'of-finished-header__image'} alt={'Thanks All Good'} />
                    <div className={'of-finished-header__heading text-font-1-100'}>Thanks!{renderText()}
                    </div>
                </div>)
            }
        }
        return (<></>)
    }

    const renderDescription = () => {
        const renderFraudDescription = () => {
            return (
                <div className={'of-finished-description'}>
                    <div className={'of-finished-description__item'}>
                        <div className={'of-finished-description__title text-font-2-100'}>What do you need to check?</div>
                        <div className={'of-finished-description__text text-font-3-100'}>
                            Our fraud prevention system has detected that some details on this order may not be correct, and has recommended
                            we take a look to confirm.
                      </div>
                    </div>
                    <div className={'of-finished-description__item'}>
                        <div className={'of-finished-description__title text-font-2-100'}>What happens now?</div>
                        <div className={'of-finished-description__text text-font-3-100'}>Our staff will manually review your order shortly.
                          You will receive an email advising you of the {`review's`} outcome, and will outline any further steps you need to take.
                      </div>
                    </div>
                    <div className={'of-finished-description__item'}>
                        <div className={'of-finished-description__title text-font-2-100'}>Has any payment been taken?</div>
                        <div className={'of-finished-description__text text-font-3-100'}>No payment has been taken or charged yet. If your
                        order is accepted, you will receive an email with information on how to complete the order.
                      </div>
                    </div>
                </div>
            )
        }
        const renderSuccessDescription = (email) => {
            return (
                <div className={'of-finished-description'}>
                    <Feedback requestUser={requestUser} />
                    <div className={'of-finished-description__item'}>
                        <div className={'of-finished-description__title text-font-2-100'}>What happens next?</div>
                        <div className={'of-finished-description__text text-font-3-100'}>
                            We have sent an email to <strong>{email}</strong> with your order confirmation and receipt. {`If the email hasn't arrived`} within 10 minutes please check your spam or junk folder. You are now ready to login to your account.
                      </div>
                    </div>
                    <div className={'of-finished-description__item'}>
                        <div className={'of-finished-description__title text-font-2-100'}>Logging in</div>
                        <div className={'of-finished-description__text text-font-3-100'}>Your <a
                            className={'primary-font-1-100'} href={getAppConfigValue('ccp_link')}
                            target={'_blank'}>{getAppConfigValue('ccp_name')}</a> account is the destination where you manage all of your {getAppConfigValue('company_name')} services, submit support tickets and access your Billing and Account details.
                      </div>
                    </div>
                    <div className={'of-finished-description__item'}>
                        <div className={'of-finished-description__title text-font-2-100'}>Be sure to whitelist us!</div>
                        <div className={'of-finished-description__text text-font-3-100'}>{`To avoid having emails from us incorrectly blocked by your
                  spam filter, please ensure that '${getRootDomain()}' is added to your white-list.`}
                        </div>
                    </div>
                </div>
            )
        }
        if (requestUser.status === 'success' && requestUser.data && requestUser.data.attributes && finished) {
            const { email } = requestUser.data.attributes
            const { manual_review } = finished
            if (manual_review) {
                return (renderFraudDescription())
            } else {
                return (renderSuccessDescription(email))
            }
        } else {
            if (finished && finished.manual_review) {
                return (renderFraudDescription())
            }
        }
        return (<></>)
    }
    const getRootDomain = () => {
        const cookie = getAppConfigValue('cookie_domain')
        if (getAppConfigValue('cookie_domain')) {
            return cookie.replace(".", "")
        }
        return null
    }
    const renderSidebar = (mobile = false) => {
        if (requestInvoice.status === 'success' && requestInvoice.data && requestInvoice.data.attributes && finished && Object.keys(finished).length > 0) {
            const { subtotal, total, tax, credit } = requestInvoice.data.attributes
            const getCredit = () => {
                if (!credit || credit === "0.00") {
                    return null

                }
                return parseFloat(credit).toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)
            }
            const renderOrderSummary = () => {
                return (
                    <div className={'of-finished-sidebar-item'}>
                        <div className={'of-finished-sidebar-item__heading text-font-2-100'}>Order Summary</div>
                        <ul className={'of-finished-sidebar-item__list'}>
                            <li>
                                <div className={'label text-font-3-100'}>Sub total</div>
                                <div className={'value text-font-2-100'}>${parseFloat(subtotal).toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}</div>
                            </li>

                            {getCredit() ?
                                <li>
                                    <div className={'label text-font-3-100'}>Credit</div>
                                    <div className={'value text-font-2-100'}>${getCredit()}</div>
                                </li> : <></>}

                            <li>
                                <div className={'label label--standout text-font-2-100'}><strong>Order Total</strong>
                                </div>
                                <div className={'value value--standout text-font-2-100'}><strong>${parseFloat(total).toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}</strong></div>
                            </li>
                            <li>
                                <div className={'label text-font-3-100'}>GST Inclusive</div>
                                <div className={'value text-font-2-100'}>${parseFloat(tax).toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}</div>
                            </li>
                        </ul>
                    </div>
                )
            }
            const renderPaymentDetails = () => {
                const { payInvoicePayload, savedCards } = finished
                const renderPayment = () => {
                    if (payInvoicePayload) {
                        const { payment_option, cc_id } = payInvoicePayload
                        const renderPaymentType = () => {
                            if (parseFloat(total) && parseFloat(credit) && parseFloat(total) === parseFloat(credit)) {
                                return (<></>)
                            }
                            if (parseFloat(total) === 0) {
                                return (<></>)
                            }
                            return (
                                <li>
                                    <div className={'label text-font-3-100'}>Payment Type</div>
                                    <div className={'value text-font-2-100'}>{payment_option}</div>
                                </li>
                            )
                        }

                        if (payment_option === NEW_CREDIT_CARD || payment_option === SAVED_CREDIT_CARD) {
                            const getLastFourCardNumber = () => {
                                if (payment_option === NEW_CREDIT_CARD) {
                                    const { card_number } = payInvoicePayload
                                    if (card_number) {
                                        return card_number.substr(card_number.length - 4);
                                    }
                                    return (<></>)
                                } else if (payment_option === SAVED_CREDIT_CARD) {
                                    if (savedCards && savedCards.length > 0) {
                                        const selectedCC = savedCards.find(item => item.attributes.card_id === cc_id)
                                        const { card_last_four } = selectedCC.attributes
                                        return card_last_four
                                    }

                                }
                            }
                            return (<>
                                <li>
                                    <div className={'label text-font-3-100'}>Payment Type</div>
                                    <div className={'value text-font-2-100'}>{payment_option}</div>
                                </li>
                                <li>
                                    <div className={'label text-font-3-100'}>Credit Card</div>
                                    <div className={'value text-font-2-100'}>**** **** **** {getLastFourCardNumber()}</div>
                                </li>
                                <li>
                                    <div className={'label text-font-3-100'}>Order Total</div>
                                    <div className={'value text-font-2-100'}>${parseFloat(total).toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}</div>
                                </li>
                            </>)
                        }

                        return (<>
                            {renderPaymentType()}
                            <li>
                                <div className={'label text-font-3-100'}>Total Amount</div>
                                <div className={'value text-font-1-100'}>${parseFloat(total).toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}</div>
                            </li>
                        </>)
                    }
                }
                return (
                    <div className={'of-finished-sidebar-item'}>
                        <div className={'of-finished-sidebar-item__heading text-font-2-100'}>Payment Details</div>
                        <ul className={'of-finished-sidebar-item__list'}>
                            {renderPayment()}
                        </ul>
                    </div>
                )

            }

            return (
                <aside className={`of-finished__sidebar ${mobile ? 'of-finished-sidebar-mobile' : 'of-finished-sidebar'}`}>
                    {renderOrderSummary()}
                    {renderPaymentDetails()}
                </aside>
            )
        }
        return (<></>)
    }
    return (<div className={`of-finished`}>
        <div className={'of-finished__main'}>
            <div className={'of-finished__wrapper'}>
                {renderHeading()}
                {renderSidebar(true)}
                {renderDescription()}
            </div>
        </div>
        {renderSidebar()}
        {renderLoading()}
    </div>)
}

Finished.propTypes = {
    history: PropTypes.any,
    location: PropTypes.any
}

Finished = withRouter(Finished)

export default Finished